import { Component }      from '@angular/core';
import { NavController }  from 'ionic-angular';
import { NavParams }      from 'ionic-angular';

import { Mixture }        from '../../shared/models/mixture';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  selector:    'page-molecule-result',
  templateUrl: 'molecule-result.html'
})

export class MoleculeResultPage
{
  mixtures      : Mixture[]  = [];
  selectedValue : string     = '';
  composition   : string     = '';

  constructor(public navCtrl   : NavController,
              public navParams : NavParams,
              private analytics  : GoogleAnalytics)
  {
    this.selectedValue = this.navParams.get('val');
    this.mixtures      = this.navParams.get('equivalent');
    this.composition   = this.navParams.get('compo');
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Molecule results " + this.selectedValue);
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }

  getComposition(selectedMixtures)
  {
    var moleculeCompo = '';

    if(selectedMixtures.N2 != null)
      moleculeCompo = moleculeCompo + selectedMixtures.N2 + '% N2, ';

    if(selectedMixtures.O2 != null)
      moleculeCompo = moleculeCompo + selectedMixtures.O2 + '% O2, ';

    if(selectedMixtures.CO2 != null)
      moleculeCompo = moleculeCompo + selectedMixtures.CO2 + '% CO2, ';

    if(selectedMixtures.He != null)
      moleculeCompo = moleculeCompo + selectedMixtures.He + '% He, ';

    if(selectedMixtures.Ar != null)
      moleculeCompo = moleculeCompo + selectedMixtures.Ar + '% Ar, ';

    if(selectedMixtures.H != null)
      moleculeCompo = moleculeCompo + selectedMixtures.H + '% H, ';

    if(selectedMixtures.NO != null)
      moleculeCompo = moleculeCompo + selectedMixtures.NO + '% NO ,';

    moleculeCompo = moleculeCompo.substr(0, moleculeCompo.length - 2);

    return moleculeCompo;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/molecule-result/molecule-result.ts